import { ProfileType } from '../profileType';
import type { User } from '../types';

import { getProfileType } from './getProfileType';

export function isClientUser(user: User | undefined): boolean {
  return !!user && getProfileType(user) === ProfileType.Client;
}
